export const isImage = (url) => {
	return /\.(png|jpe?g|gif|svg|webp)(\?|#|$)/i.test(url);
};

export const isNativeVideo = (url) => {
	return /\.(mp4|webm|avi|mov)(\?|#|$)/i.test(url);
};

export const isPDF = (url) => {
	return /\.pdf(\?|#|$)/i.test(url);
};

export const isYoutube = (url) => {
	return /youtube\.com|youtu\.be/i.test(url);
};

export const getYoutubeId = (url) => {
	return url?.replace(/^https?:\/\/((www\.)?youtube\.(.+)[?&]v=|youtu\.be\/)([^?&/#]+).*$/i, '$4');
};